import React from 'react';
import { HandleLettersDetails } from 'modules/handle-letters';

export default class ThuHoiXuLyDonPage extends React.Component {

  render() {
    return (
      <HandleLettersDetails params={this.props.params} thuHoi={true} route={this.props.route}/>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/handle-letters-old/ThuHoiXuLyDonOldPage.jsx